import {createMuiTheme} from '@material-ui/core/styles';
import {snackbarZIndex} from './utils/gaia/zIndicies';

export const SPACING_UNIT = 8;
export const AVATAR_WIDTH = 48;

import {
    GRANITE_1,
    GRANITE_2,
    GRANITE_3,
    GRANITE_7,
    GRANITE_8,
    SNOW_BLIND,
    SUMMER_3,
    CONIFER_3,
} from './colors';

// Include rules in here only if they're meant to apply website-wide.
// One-off changes should be implemented downstream.
export default createMuiTheme({
    palette: {
        primary: {
            main: CONIFER_3,
        },
        secondary: {
            main: SUMMER_3,
        },
        error: {
            main: SUMMER_3,
        },
    },

    typography: {
        fontSize: 11,
        htmlFontSize: 10,
        fontFamily: ['Inter', 'Helvetica Neue', 'Helvetica', 'Arial', 'sans-serif'],
        fontWeightBold: 600,

        button: {
            textTransform: 'none',
        },

        h6: {
            fontWeight: 'bold',
            lineHeight: 'normal',
        },

        caption: {
            fontSize: 11,
            color: GRANITE_3,
        },

        body2: {
            lineHeight: 1.5,
        },
    },

    spacing: SPACING_UNIT,

    props: {
        MuiButtonBase: {
            disableRipple: true,
        },

        MuiExpansionPanel: {
            elevation: 0
        },

        MuiMenu: {
            anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left'
            },
            getContentAnchorEl: null
        },
        MuiAvatar: {
            variant: 'rounded',
        }
    },

    overrides: {

        MuiListSubheader: {
            root: {
                borderBottomColor: GRANITE_7,
                borderBottomStyle: 'solid',
                borderBottomWidth: 1,
                lineHeight: null,
                marginBottom: SPACING_UNIT,
                paddingBottom: SPACING_UNIT / 2,
                paddingTop: SPACING_UNIT * 2,
            },

            gutters: {
                paddingLeft: 0,
                paddingRight: 0,
                marginLeft: SPACING_UNIT * 2,
                marginRight: SPACING_UNIT * 2,
            },

            sticky: {
                backgroundColor: SNOW_BLIND
            }
        },

        MuiButton: {
            root: {
                fontSize: 14,
                '&:active, &:focus, &:hover': {
                    outline: 'none',
                    textDecoration: 'none',
                }
            }
        },

        MuiSnackbar: {
            root: {
                zIndex: snackbarZIndex,
            }
        },

        MuiSnackbarContent: {
            root: {
                fontSize: 14,
            }
        },

        MuiAvatar: {
            root: {
                border: `1px solid ${GRANITE_7}`,
                width: AVATAR_WIDTH,
                height: AVATAR_WIDTH,
            },
            colorDefault: {
                backgroundColor: GRANITE_8,
            },
            rounded: {
                borderRadius: 8,
            }
        },

        MuiListItemIcon: {
            root: {
                marginRight: SPACING_UNIT,
                minWidth: 0,
            }
        },

        MuiToolbar: {
            root: {
                width: '100%',
                maxWidth: 1170,
                margin: '0 auto'
            }
        },

        MuiTooltip: {
            tooltip: {
                fontSize: 12,
                backgroundColor: SNOW_BLIND,
                color: undefined,
                // eslint-disable-next-line max-len
                boxShadow: '0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12)'
            }
        },

        MuiMenuItem: {
            root: {
                color: GRANITE_2,
                textDecoration: 'none',
                fontSize: 14,
                '&:hover': {color: GRANITE_1},
                '&:focus': {
                    color: GRANITE_2,
                    outline: 0,
                    textDecoration: 'none'
                }
            }
        },

        MuiLink: {
            root: {
                color: '#09819F',
                cursor: 'pointer',
            }
        }
    }
});
